// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {ParagraphAlignment} from './paragraph-alignment.js'

export class SetParagraphAlignment {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): SetParagraphAlignment {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsSetParagraphAlignment(
    bb: flatbuffers.ByteBuffer,
    obj?: SetParagraphAlignment
  ): SetParagraphAlignment {
    return (obj || new SetParagraphAlignment()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsSetParagraphAlignment(
    bb: flatbuffers.ByteBuffer,
    obj?: SetParagraphAlignment
  ): SetParagraphAlignment {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new SetParagraphAlignment()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  value(): ParagraphAlignment | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : null
  }

  static startSetParagraphAlignment(builder: flatbuffers.Builder) {
    builder.startObject(1)
  }

  static addValue(builder: flatbuffers.Builder, value: ParagraphAlignment) {
    builder.addFieldInt8(0, value, null)
  }

  static endSetParagraphAlignment(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    return offset
  }

  static createSetParagraphAlignment(
    builder: flatbuffers.Builder,
    value: ParagraphAlignment | null
  ): flatbuffers.Offset {
    SetParagraphAlignment.startSetParagraphAlignment(builder)
    if (value !== null) SetParagraphAlignment.addValue(builder, value)
    return SetParagraphAlignment.endSetParagraphAlignment(builder)
  }
}
